import { LoaderPage } from '@component/loader/loader.page';

import { useVerify } from './verify.hook';

export const VerifyPage = () => {
  useVerify();

  return <LoaderPage />;
};
